<template>
  <div class="wrapper-product" :style="{ 'border-top-color': $store.getters.getData.color1 }">

    <div :id="'product-' + data.id" class="row product">
       <div class="col s3">
        <div class="a1by1 product-img" :style="{ 'background-image': 'url(' + data.product.image + ')' }"></div>
      </div>

      <div class="col s12 m9">
        <div class="row" style="margin-bottom: 0;">
          <div class="col s12 m9">
            <h2>{{data.product.name}}</h2>
            <p>{{data.product.description | truncateText(250) }}</p>
          </div>
          <div class="col s12 m3 right-align" style="margin-top: 2.8rem">
            <span v-if="data.price_old" class="price-old danger-text">{{ data.price_old | currency }}</span><br>
            <span class="price">{{data.price | currency }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col s12">
            <span>{{ $t("SHOP.QUANTITY") }}: </span>
            <span>{{data.quantity}}</span> <span v-if="data.product.stock<data.quantity" class="danger-text">({{$t("SHOP.NO-STOCK")}})</span>
            <div v-for="feature in data.features" :key="feature.id">
              <span>{{feature.feature.name}}: </span>
              <span>{{feature.selected_value.value}}</span>
            </div>
            <div v-for="option in data.options" :key="option.id">
              <span>{{option.name}}: </span>
              <span>{{option.value}}</span>
            </div>
          </div>
          <div class="col 12" style="margin-top: 1rem;">
            <!-- <a v-on:click="modifyProduct" v-on:keyup.enter="modifyProduct" class="waves-effect waves-light btn-large focusable" tabindex="-1" v-on:focus="onFocus">{{ $t("SHOP.MODIFY") }}</a> -->
            <a v-on:click="deleteProduct" v-on:keyup.enter="deleteProduct" class="waves-effect waves-light btn-large focusable" tabindex="-1" v-on:focus="onFocus">{{ $t("SHOP.DELETE") }}</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import SpatialNavigation from 'js-spatial-navigation'
import { isInViewport } from '@/utils/helper-functions'

export default {
  name: 'CartProduct',
  props: ['data', 'autoFocus'],
  data () {
    return {
      products: {}
    }
  },
  created: function () {
    // if (this.data.product.product_features.length) {
    //   // actualizar precio y stock
    // }
  },
  mounted: function () {
    this.SN = SpatialNavigation.add({selector: '#product-' + this.data.id + ' .focusable', restrict: 'self-first', straightOnly: true})
    SpatialNavigation.makeFocusable(this.SN)
    // if (this.autoFocus) { SpatialNavigation.resume(); SpatialNavigation.focus(this.SN) }
    SpatialNavigation.resume()
  },
  methods: {
    deleteProduct: function () {
      this.$emit('deleteProduct', { id: this.data.id, sn: this.SN })
    },
    modifyProduct: function () {
      this.$emit('modifyProduct', {
        id: this.data.id,
        product: this.data.product,
        features: this.data.features,
        quantity: this.data.quantity,
        sn: this.SN
      })
    },
    onFocus: function () {
      if (!isInViewport(this.$el)) {
        this.$el.scrollIntoView()
      }
    }
  },
  beforeDestroy: function () { if (this.SN) SpatialNavigation.remove(this.SN) }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>

.wrapper-product
  position: relative
  width: 94vw
  margin: auto
  background-color: #fff
  border-top-width: .3rem
  border-top-style: solid
  margin-top: .4rem
  margin-bottom: 47px
  word-wrap: break-word;

  .product-img
    background-position: center center
    background-repeat: no-repeat
    background-size: cover

  h2
    font-weight: bold
    font-size: 1.9rem

  p, span
    font-size: 1.2rem

  .price-old
    text-decoration: line-through;
    font-size: 2.1rem

  .price
    font-weight: bold
    font-size: 2.1rem

.danger-text
  color: red!important
</style>



// WEBPACK FOOTER //
// src/components/CartProduct.vue